import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './CartPage.css';

export default function CartPage() {
  const { items, updateQuantity, removeItem, clearCart, total, itemCount } = useCart();
  const navigate = useNavigate();
  const [showClearConfirm, setShowClearConfirm] = React.useState(false);

  if (items.length === 0) {
    return (
      <div className="container page-center">
        <div className="empty-cart-icon">&#128722;</div>
        <h2>Your cart is empty</h2>
        <p className="empty-cart-text">Browse the menu and add some delicious items!</p>
        <Link to="/" className="btn btn-primary">Browse Menu</Link>
      </div>
    );
  }

  return (
    <main className="cart-page container">
      <div className="cart-header">
        <h2>Your Order</h2>
        <button className="btn btn-sm btn-outline" onClick={() => setShowClearConfirm(true)}>
          Clear All
        </button>
      </div>

      {showClearConfirm && (
        <div className="clear-confirm card">
          <p>Clear all items from your cart?</p>
          <div className="clear-confirm-actions">
            <button className="btn btn-sm btn-danger" onClick={() => { clearCart(); setShowClearConfirm(false); }}>
              Yes, Clear
            </button>
            <button className="btn btn-sm btn-outline" onClick={() => setShowClearConfirm(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div className="cart-items">
        {items.map((item) => (
          <div key={item._key} className="cart-item card">
            <div className="cart-item-info">
              <h3 className="cart-item-name">
                {item.name}
                {item.optionsLabel && <span className="cart-item-options">{item.optionsLabel}</span>}
              </h3>
              <p className="cart-item-price">${(item.price * item.quantity).toFixed(2)}</p>
            </div>
            <div className="cart-item-controls">
              <div className="qty-control">
                <button
                  className="qty-btn"
                  onClick={() => updateQuantity(item._key, item.quantity - 1)}
                >
                  &minus;
                </button>
                <span className="qty-value">{item.quantity}</span>
                <button
                  className="qty-btn qty-btn-add"
                  onClick={() => updateQuantity(item._key, item.quantity + 1)}
                >
                  +
                </button>
              </div>
              <button
                className="cart-item-remove"
                onClick={() => removeItem(item._key)}
                title="Remove item"
              >
                &times;
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-summary card">
        <div className="cart-summary-row">
          <span>Items ({itemCount})</span>
          <span>${total.toFixed(2)}</span>
        </div>
        <div className="cart-summary-total">
          <span>Total</span>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>

      <button
        className="btn btn-primary btn-block checkout-btn"
        onClick={() => navigate('/checkout')}
      >
        Proceed to Checkout &rarr;
      </button>

      <button
        type="button"
        className="cart-back-to-menu"
        onClick={() => navigate('/')}
      >
        &larr; Back to Menu
      </button>
    </main>
  );
}
